import React from 'react'
import PropTypes from 'prop-types'
import { WarningIcon } from '../../../../uiKit/icons/Icons'
import classes from './styles.module.scss'

/**
 * Warning banner shown when the email integration health check fails.
 */
const HealthStatusBanner = ({ visible }) => {
    if (!visible) return null

    return (
        <div className={classes.healthStatusContainer}>
            <div className={classes.healthStatusIcon}>
                <WarningIcon />
            </div>
            <div className={classes.healthStatusContent}>
                <div className={classes.healthStatusTitle}>Email integration disconnected</div>
                <div className={classes.healthStatusSubtext}>
                    The email service connection failed. Please contact the support for assistance.
                </div>
            </div>
        </div>
    )
}

HealthStatusBanner.propTypes = {
    visible: PropTypes.bool.isRequired,
}

export default HealthStatusBanner
